import React, { useContext, useEffect, useState } from "react";
import arePropsEqual from "react-fast-compare";
import { useSelector } from "react-redux";
import { Checkbox } from "@mui/material";

//context
import { WebhooksReportContext } from "../../WebhooksReportContext";

//selectors
import { selectListData } from "../../../../../../store/admin/reports/webhooks_report/selectors";

//hooks
import { usePermissions } from "../../../../../../store/common/configuration/usePermissions";

//utils
import { canWebhookResend } from "../../utils";

//constants
import { BULK_RESEND_LIMIT } from "../../constants";

const SelectAllWebhooksReport = () => {
  const context = useContext(WebhooksReportContext);
  const data = useSelector(selectListData);
  const { hasPermissions } = usePermissions();

  const hasResendPermission = hasPermissions(["api2.admin.webhookstaskscontroller.resend"]);

  const [checked, setChecked] = useState<boolean>(false);

  const getSelectableList = () => (data?.list || []).filter((item: any) => canWebhookResend(item.created_at, item.status));

  useEffect(() => {
    if (!context.selectedWebhooks.length) {
      setChecked(false);
    }
  }, [context.selectedWebhooks]);

  useEffect(() => {
    if (!!data) {
      const selectableList = getSelectableList();
      const idsA = new Set(context.selectedWebhooks.map(({ id }: any) => id));
      const allMatched = !!selectableList.length && selectableList.every(({ id }: any) => idsA.has(id));
      if (!allMatched) {
        setChecked(false)
      }
      if (allMatched) {
        setChecked(true)
      }
    }
  }, [data, context.selectedWebhooks])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!!data && event.target.checked) {
      const selectableList = getSelectableList();
      const selectedIds = new Set(context.selectedWebhooks.map(({ id }: any) => id));
      const newItemsCount = selectableList.filter(({ id }: any) => !selectedIds.has(id)).length;

      if (context.selectedWebhooks.length + newItemsCount > BULK_RESEND_LIMIT) {
        context.showBulkLimitAlert();
        return;
      }

      setChecked(true);
      context.setSelectedWebhooks((prevState: any) => {
        const toAdd = selectableList.filter((item: any) =>
          !prevState.some((existing: any) => existing.id === item.id)
        );
        return [...prevState, ...toAdd];
      });
    } else {
      setChecked(false);
      context.setSelectedWebhooks((prevState: any) => {
        if (!data) return prevState;
        const incomingIds = new Set(data.list.map((item: any) => item.id));
        return prevState.filter((item: any) => !incomingIds.has(item.id));
      })
    }
  }

  if (!hasResendPermission) {
    return null;
  }

  return (
    <Checkbox
      size="small"
      sx={{ padding: '4px' }}
      checked={checked}
      onChange={handleChange}
      inputProps={{ 'aria-label': 'controlled' }}
    />
  );
};

export default React.memo(SelectAllWebhooksReport, arePropsEqual);
